import React from 'react';

import { ScheduledPaymentsBatchesLoader } from 'modules/reimbursements/components/ScheduledPaymentsBatchesList/ScheduledPaymentsBatchesLoader';

export const ExpenseClaimsHistoryPageSkeleton = () => {
  return (
    <div className="p-24">
      <div className="mx-auto w-full max-w-lg">
        <ScheduledPaymentsBatchesLoader count={2} />
      </div>
    </div>
  );
};
